// extracted by mini-css-extract-plugin
module.exports = {"form":"MarkQueryConfig_form_17tEt","el-input":"MarkQueryConfig_el-input_1Jifv"};